import { JWTAuth } from "../../../../lib/js-apiclient"
import { AdvancedApiClient } from "../../../../lib/js-apiclient/src/AdvancedApiClient";

export class FarfetchGenderMapApiClient extends AdvancedApiClient {

    static entityType = "FarfetchGenderMap"

    constructor(token, genderId, id) {
        super();

        this.setEntityType(FarfetchGenderMapApiClient.entityType)

        if(id !== undefined && id !== null) {
            this.setRoute("/api/v1/gender/{gid}/farfetch-map/{id}")
                .setRouteParam("gid", genderId)
                .setRouteParam("id", id);
        } else {
            this.setRoute("/api/v1/gender/{gid}/farfetch-map")
                .setRouteParam("gid", genderId);
        }
        
        if(token !== undefined && token !== null) {
            this.appendAuthSchema(new JWTAuth(token))
        }
    }

}